import { render, staticRenderFns } from "./AddGroup.vue?vue&type=template&id=5ebb576f&"
import script from "./AddGroup.vue?vue&type=script&lang=ts&"
export * from "./AddGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports